import { t } from '../../locales/index';

export const required = (val) => {
	return (val !== undefined && val !== null && val !== '') || t('validators.required');
};

export const isEmail = (val) => {
	return /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/.test(val) || t('validators.is-email');
};

export const minLength = (minLength) => (val) => {
	if (typeof val !== 'string') return true;
	return val.length >= minLength || t('validators.min-length', [minLength]);
};

export const maxLength = (maxLength) => (val) => {
	if (typeof val !== 'string') return true;
	return val.length <= maxLength || t('validators.max-length', [maxLength]);
};

export const minValue = (minValue) => (val) => {
	if (typeof val !== 'number') return true;
	return val >= minValue || t('validators.min-value', [minValue]);
};

export const maxValue = (maxValue) => (val) => {
	if (typeof val !== 'number') return true;
	return val <= maxValue || t('validators.max-value', [maxValue]);
};

export const minArrayLength = (minLength) => (val) => {
	if (typeof minLength !== 'number') return true;
	if (!Array.isArray(val)) return true;
	return val.length >= minLength || t('validators.min-number-of-items', [minLength]);
};

export const maxArrayLength = (maxLength) => (val) => {
	if (typeof maxLength !== 'number') return true;
	if (!Array.isArray(val)) return true;
	return val.length <= maxLength || t('validators.max-number-of-items', [maxLength]);
};

export const isPhoneNumber = (val) => {
	if (typeof val !== 'string') return true;
	return /^(5)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/u.test(val) || t('validators.is-phone-number');
};

export const isPhoneNumberWithCountryCode = (val) => {
	if (typeof val !== 'string') return true;
	return (
		/^(9665)(5|0|3|6|4|9|1|8|7)([0-9]{7})$/u.test(val) ||
		t('validators.is-phone-number-with-country')
	);
};

export const alphabetAndArabicAndSpacesRegexp = (val) => {
	return (
		/^([a-zA-Z\u0621-\u064A\s]+|)$/.test(val) ||
		t('templates.createEdit.alphabetAndArabicAndSpacesValidation')
	);
};

export const notOnlySpaces = (val) => {
	return val.trim() !== '' || t('templates.createEdit.alphabetAndArabicAndSpacesValidation');
};

export const isUrl = (val) => {
	const regexpUrl = /^(https?:\/\/[^\s/$.?#].[^\s]*|)$/; // fragment locator;
	return regexpUrl.test(val) || t('templates.createEdit.urlValidation');
};

export const englishCharacters = (val) => {
	if (!val) return true;
	return /^[a-zA-Z ]+$/.test(val) || t('validators.english-characters');
};

export const minDate = (minDate) => (val) => {
	if (!val || !minDate) return true;
	const date = new Date(val);
	const min = new Date(minDate);
	return date >= min || t('validators.min-date', [minDate]);
};

export const maxDate = (maxDate) => (val) => {
	if (!val || !maxDate) return true;
	const date = new Date(val);
	const max = new Date(maxDate);
	return date <= max || t('validators.max-date', [maxDate]);
};

export const globalValidators = {
	required,
	isEmail,
};

export const isAlphaNumeric = (val) => {
	if (!val) return true;
    return /^[a-zA-Z0-9-]+$/.test(val) || t('validators.is-alpha-numeric');
};
